import React from "react";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { withStyles } from "tss-react/mui";
import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../utils/formatting";
import SubsDebtorGeneral from "./Tabs/SubsDebtorGeneral";

const endPoint = "core/subsDebtor";

function SubsDebtorForm() {
  return (
    <AuthProvider prefix={"subsDebtors"}>
      <JamezzFormV2
        computedPageTitle={function (model) {
          return formatTitle(this.pageTitle, model.company_name);
        }}
        endPoint={endPoint}
        mode={"onSubmit"}
        pageTitle={getTranslation("subDebtors.form.pageTitle", "Debtor")}
        revalidateMode={"onChange"}
        tabs={[
          {
            right: "general",
            tabButton: <TranslationWrapper tDefault={"General"} tKey={"subsDebtors.form.tabs.general"} />,
            tabContent: <SubsDebtorGeneral />,
          },
        ]}
      />
    </AuthProvider>
  );
}

export default withStyles(SubsDebtorForm, vestigingStyle);
